export default "/images/user-icon.png?8e3823599e06b6ff450b41e9493b00ab";